import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const EasyIcon = (props: IconProps) => {
  return (
    <Icon
      fill="none"
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#FFCC4D" d="M72 36a36 36 0 1 1-72 0 36 36 0 0 1 72 0Z" />
      <path
        fill="#292F33"
        fillRule="evenodd"
        d="M2.5 22c.5.5 2.9 2 3.3 3.4.5 1.4 1.5 9.6 4.3 12 3 2.4 14.2 1.5 16.3.4 4.8-2.4 5.4-9 6.3-12.4.5-2 3.3-2 3.3-2s3 0 3.4 2c.8 3.4 1.4 10 6.2 12.4 2.2 1.1 13.3 2 16.3-.4 2.9-2.4 3.8-10.6 4.3-12 .5-1.4 2.9-2.9 3.4-3.4.5-.4.5-2.4 0-2.8-1-1-12.3-1.8-24.5-.5-2.4.3-3.3 1-9 1-5.8 0-6.8-.7-9.2-1a70.8 70.8 0 0 0-24.4.5c-.5.4-.5 2.4 0 2.8Z"
        clip-rule="evenodd"
      />
      <path
        fill="#664500"
        d="M54.7 47.3a1 1 0 0 0-1.3-.1S45.6 53 36 53c-9.5 0-17.3-5.7-17.4-5.8a1 1 0 0 0-1.5 1.3A23 23 0 0 0 36 59a23 23 0 0 0 18.9-10.5 1 1 0 0 0-.2-1.2Z"
      />
    </Icon>
  );
};

export default EasyIcon;
